import { render, staticRenderFns } from "./sub-bubble-agreements-list.vue?vue&type=template&id=d6f84d8a"
import script from "./sub-bubble-agreements-list.vue?vue&type=script&lang=js"
export * from "./sub-bubble-agreements-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports